import classnames from "classnames";
import React, { ReactNode } from "react";

interface IProps {
  children: ReactNode;
  className?: string;
  sm?: number;
  md?: number;
  lg?: number;
  xl?: number;
}

const Col = ({ children, className, sm, md, lg, xl }: IProps): JSX.Element => {
  return (
    <div
      className={classnames(
        className,
        sm && `col-sm-${sm}`,
        md && `col-md-${md}`,
        lg && `col-lg-${lg}`,
        xl && `col-xl-${xl}`
      )}
    >
      {children}
    </div>
  );
};

export default Col;
